import Header from './components/Header';
import Hero from './components/Hero';
import FeedSection from './components/FeedSection';
import { ColumnsSection, RealSection } from './components/ContentSections';
import { FaqSection, VoiceSection } from './components/TrustSections';
import { SubmitSection, BackTop } from './components/SubmitSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FeedSection />
        <ColumnsSection />
        <RealSection />
        <FaqSection />
        <VoiceSection />
        <SubmitSection />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}